import * as types from './../constants/actionTypes';
import { UPDATE_BALANCE_TOPUPEWALLET, GET_PAYMENT_STATUS,
         GET_PAYMENT_FORM} from './../constants/restURLs';
import { fetchApi } from './../api';
import {alertFailed, alertSuccess} from './AlertActions';
import {getBalanceAccount, saveBalanceAccount} from './infoAccountActions';
import { showLoadingIndicator } from './loginActions';
import { STATUS_OK, STATUS_PENDING, STATUS_ERROR } from '../constants/reponseTypes';

const onUpdateBalanceTopUpEwalletSuccessful = (htmlForm, xid) => {
    return {
        type: types.UPDATE_BALANCE_TOPUPEWALLET_SUCCESSFUL,
        htmlForm,
        xid
    }
}

const onUpdateBalanceTopUpEwalletFailed = () => {
    return {
        type: types.UPDATE_BALANCE_TOPUPEWALLET_FAILED
    }
}

const closeHtmlForm = () => {
    return {
        type: types.CLOSE_HTML_FORM
    }
}

export const  onCloseHtmlForm = () => (dispatch) => {
    dispatch(closeHtmlForm());
}

export function getPaymentRedirectHtmlForm(accountId, amount, currency) {
  return function (dispatch) {
    let lang = localStorage.getItem('lang');
    let params = "accountId=" + accountId
                 + "&amount=" + amount
                 + "&currency=" + currency
                 + "&lgeCode=" + lang;

    console.log("params", params);
    let btmCnt = document.getElementById('bottomCntCredit');
    dispatch( showLoadingIndicator(true) );
    let callbacks = {
      onSuccess: (response) => {
        console.log('onSuccess:');
        console.log('sign up response', response);
        dispatch( showLoadingIndicator(false) );
        if (response.status == STATUS_OK){
            let outXid = response.xid;
            let htmlForm = response.htmlForm;
            dispatch( saveHtmlForm( htmlForm ) );
            getSimplePaymentStatus(outXid, dispatch);
            btmCnt.style.marginTop = '0px';
        }

        if (response.message)
          dispatch( alertSuccess(response.message) );
      },
      onFailed: (response, statusCode) => {
        console.log('onFailed:');
        dispatch( showLoadingIndicator(false) );
        dispatch( alertFailed(response.message) );
      },
      onError: (error) => {
        console.log('onError:');
        dispatch( showLoadingIndicator(false) );
      }
    }
    fetchApi(dispatch, GET_PAYMENT_FORM, params, callbacks);
  };
}

var timerId = 0;
export function getSimplePaymentStatus(xid, dispatch) {
  //five seconds interval response
  let btmCnt = document.getElementById('bottomCntCredit');
  timerId = setInterval(function() {
    let lang = localStorage.getItem('lang');
    let params = "xid=" + xid + "&lgeCode=" + lang;
    console.log("params", params);
    let callbacks = {
      onSuccess: (response) => {
        console.log('onSuccess:', response);
        if (response.status == STATUS_OK){
          dispatch( saveBalanceAccount(response.balance) );
          dispatch( saveHtmlForm( "" ) );
          btmCnt.style.marginTop = '308px';
          clearInterval(timerId);
        }
        dispatch( alertSuccess(response.message) );
      },
      onFailed: (response, statusCode) => {
        console.log('onFailed:');
        dispatch( saveHtmlForm( "" ) );
        btmCnt.style.marginTop = '308px';
        clearInterval(timerId);
        dispatch( alertFailed(response.message) );
      },
      onError: (error) => {
        console.log('onError:');
      }
    }
    fetchApi(dispatch, GET_PAYMENT_STATUS, params, callbacks);
  }, 5000);

}

export const saveHtmlForm = (htmlForm) => {
  return {
    type: types.SAVE_HTML_FORM,
      htmlFormSimple: htmlForm
  }
}

export const stopStatusSimpleCheking = () => {
  if (timerId)
    clearInterval(timerId);
}

export const  updateBalanceTopUpEwollet = (accountId, amount, cardNumber, cardCompany, cardHolder, expiryMonth, expiryYear, cvv) =>(dispatch) => {
  let lang = localStorage.getItem('lang');
  let params = `accountId=${accountId}&amount=${amount}&cardNumber=${cardNumber}&cardCompany=${cardCompany}&cardHolder=${cardHolder}&expiryMonth=${expiryMonth}&expiryYear=${expiryYear}&cvv=${cvv}&lgeCode=${lang}`;
    console.log('updateBalanceTopUpEwollet', params);
     let callbacks = {
        onSuccess: (response) => {
            console.log('response succes', response);
            dispatch(onUpdateBalanceTopUpEwalletSuccessful(response.htmlForm, response.xid));
        },
        onFailed: (response, statusCode) =>{
            console.log('response fail', response, statusCode);

            dispatch(onUpdateBalanceTopUpEwalletFailed())
            statusCode
            ? dispatch(alertFailed(response.statusText+' '+statusCode))
            : dispatch(alertFailed(response.message))
        },
        onError: (error) => {
            dispatch(onUpdateBalanceTopUpEwalletFailed())
            console.log('response error', error);
        }
    }
    fetchApi(dispatch, UPDATE_BALANCE_TOPUPEWALLET, params, callbacks );
}

const setPaymentStatus = (paymentStatus, paymentDescription) => {
    return {
        type: types.SET_PAYMENT_STATUS,
        paymentStatus,
        paymentDescription
    }
}

const showPaymentStatusProgress = () => {
    return {
        type: types.SET_PAYMENT_STATUS_PROGRESS,
    }
}

export const getPaymentStatus = (xid) => (dispatch, getState) => {
    let lang = localStorage.getItem('lang');
    let params = `xid=${xid}&lgeCode=${lang}`;
    let {accountId} = getState().authReducer;

    console.log('getPaymentStatus',params );

    let callbacks = {
        onSuccess: (response) => {
            dispatch(setPaymentStatus(response.status, response.message))
            console.log('getPaymentStatus onSuccess', response.status )
            if (response.status){
                dispatch(getBalanceAccount(accountId));
                dispatch(alertSuccess(response.message));
            }
          },
        onFailed: (response, statusCode)=> {
            console.log('getPaymentStatus Faild', response.status )
            dispatch(setPaymentStatus(response.status, response.message));
            dispatch(alertFailed(response.message));
          },
        onError: (error) => {
            dispatch(setPaymentStatus(error));
        }
      }

      fetchApi(dispatch, GET_PAYMENT_STATUS, params, callbacks);
}



// WEBPACK FOOTER //
// ./src/actions/creditCardActions.js